import type { UsersFilterInputType } from "@/types/graphql/partner.generated";

/**
 * Значения фильтра из querystring в аргумент `users(filter:)`. Единая сборка
 * для списка и кнопки отчёта: кнопка отправляет ровно то, что видит список.
 */
export function buildUsersFilter(
  filter: Record<string, unknown>
): UsersFilterInputType {
  return {
    search: (filter.search as string | undefined) || undefined,
  };
}
